import { keys } from 'app/config/keys';

export function logError(error: unknown, componentStack?: null | string): void {
  if (keys.__DEV__) {
    console.error(error);

    if (componentStack) {
      console.error(componentStack);
    }
  }

  // logging to 3rd party service could be added here
}
